export default (obj) => {
    const isNullish = Object.values(obj).every(value => {
        if (value === null) {
            return true;
        }

        return false;
    });
    return isNullish;
}
